export default import.meta.ROLLDOWN_FILE_URL_0w7syAGSRItZPv38NHpayA